/*
Util function to make sure appropriate categories are shown for crawlers
Some top level categories are nested under other categories and we need to make
sure they are available on certain pages for bots to index

Specifically 'accessores', 'bags', and 'jewelry' were not being rendered on specific pages.
Which would me a missed growth opportunity for SEO.
 */

export const getCrawlerChildrenCategories = ({ categories, query, pathname }) => {
  const crawlerCategoryList = [];
  const topLevelCategories = new Set(['sneakers', 'apparel', 'accessories', 'bags', 'jewelry']);

  const getCategories = (children) => {
    if (!children) {
      return false;
    }

    for (const category of children) {
      if (pathname.includes('brand') && query?.slug) {
        if (topLevelCategories.has(category.value)) {
          crawlerCategoryList.push(category);
        }
      } else {
        crawlerCategoryList.push(category);
      }
      getCategories(category?.children);
    }
  };

  const nameOfPath = pathname.split('/');
  const isBasePath =
    nameOfPath?.length &&
    nameOfPath?.[nameOfPath.length - 1] &&
    topLevelCategories.has(nameOfPath[nameOfPath.length - 1]);

  const categoryList = isBasePath
    ? categories?.filter((category) => !topLevelCategories.has(category.value))
    : categories;

  getCategories(categoryList);

  return crawlerCategoryList;
};
